import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import Utils from "@base/utils/Utils";
import StarContainer from "./StarContainer";
import Config from "../config/Config";
import ScaleManager from "../stage/ScaleManager";

export default class StarsContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.forceRoundStart.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    const back = new PIXI.Graphics()
    back.beginFill(0x000000)
    const mainMaskW = ScaleManager.currentSizes.total.width
    const mainMaskH = ScaleManager.currentSizes.total.height
    back.drawRoundedRect(0, 0, mainMaskW, mainMaskH, 15)
    back.endFill()
    this.addChild(back)

    this.MAX_STARS = 200
    this.stars = []
    this.itemsPool = []
    this.itemsContainer = new PIXI.Container()
    this.addChild(this.itemsContainer)

    this.createStars()
  }

  createStars() {
    for (let i = 0; i < this.MAX_STARS; i++) {
      const star = this.poolOut()
      const mainMaskW = ScaleManager.currentSizes.total.width
      const mainMaskH = ScaleManager.currentSizes.total.height

      star.x = Utils.randomNumber(2, mainMaskW - 2)
      star.y = Utils.randomNumber(-2, mainMaskH + 2)
      this.stars.push(star)
    }
  }

  poolIn(item) {
    this.itemsPool.push(item)
    item.visible = false
  }

  poolOut() {
    if(this.itemsPool.length == 0) {
      const p = new StarContainer()
      this.itemsContainer.addChild(p)
      this.itemsPool.push(p)
    }
    return this.itemsPool.pop()
  }

  reset() {
    Signals.tick.remove(this.update, this)
  }

  start() {
    Signals.tick.add(this.update, this)
  }

  onRoundEnd() {
    Signals.tick.remove(this.update, this)
  }

  update() {
    const starsLength = this.stars.length
    for (let i = 0; i < starsLength; i++) {
      this.stars[i].move()
    }
  }

}
